import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Free-text visitor name editor. Mirrors the user-facing add-visitor "fullName"
// field: a plain typed name. Used only for visitors with no family code (a
// visitor linked to a family code is renamed by picking a member in edit-fc).
// This dialog only collects the name; the parent saves it.
@Component({
  selector: 'app-edit-visitor-name',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-visitor-name.component.html',
  styleUrl: './edit-visitor-name.component.scss',
})
export class EditVisitorNameComponent {
  name: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditVisitorNameComponent>,
  ) {
    this.name = data?.currentName || '';
  }

  // allow only letters and spaces (same as the user-facing name field)
  onTextInput(event: KeyboardEvent): void {
    const allowed = /^[A-Za-z ]$/;
    const blockedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (!allowed.test(event.key) && !blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  continue(): void {
    const trimmed = (this.name || '').trim();
    if (!trimmed) return;
    this.dialogRef.close({ fullName: trimmed });
  }
}
